{
  "dateFormat": {
    "date": "YYYY-MM-DD",
    "time": "HH:mm",
    "dateTime": "YYYY-MM-DD HH:mm"
  },
  "common": {
    "error": "发生错误",
    "language": "语言",
    "theme": {
      "auto": "跟随系统",
      "light": "浅色模式",
      "dark": "深色模式",
      "autoFollowSystem": "跟随系统主题"
    },
    "error_boundary_title": "应用发生异常",
    "error_boundary_subtitle": "系统遇到了未预料的错误，请尝试刷新页面。",
    "reload": "刷新页面",
    "error_detail": "错误详情：",
    "save": {
      "success": "保存成功",
      "failed": "保存失败"
    },
    "action": {
      "save": "保存",
      "terminate": "终止",
      "cancel": "取消",
      "ok": "确定",
      "submit": "提交",
      "edit": "编辑",
      "add": "添加",
      "search": "搜索"
    },
    "form": {
      "association": "关联",
      "alarmTest": "警报测试"
    },
    "na": "暂无",
    "loading": "加载中...",
    "backHome": "返回首页",
    "gender": {
      "male": "男",
      "female": "女",
      "other": "其他"
    },
    "status": {
      "active": "激活",
      "inactive": "未激活",
      "pending": "待处理",
      "completed": "已完成"
    },
    "yearsOld": "{{age}} 岁",
    "manualUpdate": "手动更新"
  },
  "reload": {
    "timeout": {
      "title": "初始化超时",
      "content": "系统初始化时间过长，建议刷新页面重试。",
      "okText": "刷新",
      "cancelText": "重新登录"
    }
  },
  "note": {
    "template": {
      "placeholder": "请选择模板"
    }
  },
  "exception": {
    "404": {
      "subTitle": "抱歉，您访问的页面不存在。"
    },
    "500": {
      "subTitle": "抱歉，服务器出错了。"
    }
  },
  "auth": {
    "login": {
      "title": "登录",
      "subtitle": "欢迎回来",
      "submit": "登录",
      "success": "登录成功",
      "error": "登录失败",
      "operationFailed": "操作失败",
      "orSignInWith": "或通过以下方式登录",
      "microsoft": "Microsoft",
      "microsoftLoading": "正在处理 Microsoft 登录...",
      "microsoftFailed": "Microsoft 登录失败: {{error}}",
      "microsoftInvalidState": "无效的状态参数",
      "microsoftNoCode": "未收到授权码"
    },
    "validation": {
      "account": {
        "required": "请输入账号！",
        "maxLength": "账号长度不能超过255个字符"
      },
      "password": {
        "required": "请输入密码！",
        "maxLength": "密码长度不能超过128个字符",
        "minLengthDynamic": "密码至少需要{{length}}位！"
      },
      "email": {
        "required": "请输入邮箱地址！",
        "invalid": "请输入有效的邮箱地址！"
      },
      "field": {
        "required": "请输入{{field}}！"
      },
      "verificationCode": {
        "required": "请输入验证码！"
      },
      "confirmPassword": {
        "required": "请确认密码！"
      },
      "confirmNewPassword": {
        "required": "请确认新密码！"
      },
      "passwordMismatch": "两次输入的密码不一致！"
    },
    "register": {
      "title": "注册",
      "subtitle": "创建新账户",
      "submit": "注册"
    },
    "resetPassword": {
      "title": "重置密码",
      "subtitle": "找回您的账户",
      "submit": "重置密码",
      "email": "邮箱",
      "verificationCode": "验证码",
      "newPassword": "新密码",
      "confirmPassword": "确认新密码",
      "sendCode": "发送验证码",
      "resendCode": "重新发送",
      "resetButton": "重置密码",
      "backToSignIn": "返回登录",
      "emailPlaceholder": "请输入邮箱地址",
      "verificationCodePlaceholder": "请输入验证码",
      "newPasswordPlaceholder": "请输入新密码",
      "confirmPasswordPlaceholder": "请再次输入新密码",
      "emailRequired": "请输入邮箱地址！",
      "emailInvalid": "请输入有效的邮箱地址！",
      "verificationCodeRequired": "请输入验证码！",
      "newPasswordRequired": "请输入新密码！",
      "passwordMinLength": "密码至少需要6位！",
      "confirmPasswordRequired": "请确认新密码！",
      "passwordMismatch": "两次输入的密码不一致！",
      "codeSent": "验证码已发送",
      "sendCodeFailed": "发送验证码失败",
      "resetSuccess": "密码重置成功",
      "resetFailed": "密码重置失败",
      "countdown": "{{seconds}}秒后重新发送"
    },
    "form": {
      "account": {
        "placeholder": "请输入账号"
      },
      "password": {
        "placeholder": "请输入密码"
      },
      "email": {
        "placeholder": "请输入邮箱地址"
      },
      "newPassword": {
        "placeholder": "请输入新密码"
      },
      "confirmPassword": {
        "placeholder": "请再次输入密码"
      },
      "confirmNewPassword": {
        "placeholder": "请再次输入新密码"
      },
      "verificationCode": {
        "placeholder": "请输入验证码"
      }
    },
    "verification": {
      "getCode": "获取验证码",
      "resendIn": "{{seconds}}秒后重新发送"
    },
    "message": {
      "registerSuccess": "注册成功",
      "registerFailed": "注册失败：",
      "resetSuccess": "密码重置成功",
      "resetFailed": "密码重置失败："
    },
    "links": {
      "forgotPassword": "忘记密码？",
      "forgotPasswordShort": "忘记密码",
      "signUp": "立即注册",
      "signIn": "已有账户？立即登录",
      "backToSignIn": "返回登录"
    },
    "signIn": {
      "title": "登录",
      "subtitle": "欢迎回来",
      "username": "用户名",
      "password": "密码",
      "rememberMe": "记住我",
      "forgotPassword": "忘记密码？",
      "signInButton": "登录",
      "noAccount": "还没有账户？",
      "signUpLink": "立即注册",
      "usernamePlaceholder": "请输入用户名",
      "passwordPlaceholder": "请输入密码",
      "usernameRequired": "请输入用户名！",
      "passwordRequired": "请输入密码！"
    },
    "signUp": {
      "title": "注册",
      "subtitle": "创建新账户",
      "username": "用户名",
      "email": "邮箱",
      "password": "密码",
      "confirmPassword": "确认密码",
      "verificationCode": "验证码",
      "sendCode": "发送验证码",
      "resendCode": "重新发送",
      "signUpButton": "注册",
      "hasAccount": "已有账户？",
      "signInLink": "立即登录",
      "usernamePlaceholder": "请输入用户名",
      "emailPlaceholder": "请输入邮箱地址",
      "passwordPlaceholder": "请输入密码",
      "confirmPasswordPlaceholder": "请再次输入密码",
      "verificationCodePlaceholder": "请输入验证码",
      "usernameRequired": "请输入用户名！",
      "emailRequired": "请输入邮箱地址！",
      "emailInvalid": "请输入有效的邮箱地址！",
      "passwordRequired": "请输入密码！",
      "passwordMinLength": "密码至少需要6位！",
      "confirmPasswordRequired": "请确认密码！",
      "passwordMismatch": "两次输入的密码不一致！",
      "verificationCodeRequired": "请输入验证码！",
      "codeSent": "验证码已发送",
      "sendCodeFailed": "发送验证码失败",
      "countdown": "{{seconds}}秒后重新发送"
    }
  },
  "tempNote": {
    "title": {
      "edit": "编辑临时笔记",
      "create": "创建临时笔记"
    },
    "field": {
      "timeRange": "时间范围",
      "reason": "原因",
      "note": "笔记",
      "alarmType": "警报类型"
    },
    "placeholder": {
      "startTime": "开始时间",
      "endTime": "结束时间"
    },
    "validation": {
      "selectTimeRange": "请选择时间范围",
      "selectReason": "请选择原因",
      "inputNote": "请输入笔记内容"
    }
  },
  "notificationCall": {
    "title": {
      "edit": "编辑通知呼叫",
      "create": "创建通知呼叫"
    },
    "field": {
      "selectPeriod": "选择周期"
    },
    "validation": {
      "selectPeriod": "请选择通知类型"
    }
  },
  "arc": {
    "profile": {
      "serviceUser": {
        "ServiceUserIntegration": {
          "viewInPannovation": "在 Pannovation 中查看"
        },
        "AssociatedServiceUser": {
          "birthday": "出生日期:",
          "age": "年龄: {{age}}",
          "gender": "性别:",
          "liveStyle": "居住方式:",
          "independentLiving": "独立居住",
          "groupLiving": "群居",
          "phoneNumbers": "电话号码",
          "device": "设备",
          "address": "地址:",
          "scheme": "计划:",
          "authority": "机构:",
          "locate": "定位:",
          "lastUpdate": "上次更新 {{time}} 前"
        }
      },
      "schemeAuthority": {
        "AssociatedAuthority": {
          "phoneNumbers": "电话号码",
          "administrator": "管理员",
          "address": "地址:"
        },
        "AssociatedScheme": {
          "phoneNumbers": "电话号码",
          "administrator": "管理员",
          "authority": "机构",
          "address": "地址:"
        }
      },
      "devices": {
        "Devices": {
          "title": "设备",
          "columns": {
            "deviceName": "设备名称",
            "type": "类型",
            "guid": "GUID",
            "sn": "序列号",
            "address": "地址",
            "status": "状态",
            "action": "操作"
          },
          "type": {
            "connection": "连接",
            "device": "设备"
          },
          "action": {
            "ignore": "忽略",
            "restore": "恢复"
          },
          "messages": {
            "failedToUpdate": "更新失败"
          }
        }
      },
      "subscriptions": {
        "Subscription": {
          "title": "订阅",
          "items": {
            "sub01": {
              "name": "订阅 01",
              "tier": "黄金",
              "note": "包含一些服务。服务内容描述，服务内容描述",
              "validity": "有效期至：2025-12-31"
            },
            "sub02": {
              "name": "订阅 02",
              "tier": "白银",
              "note": "包含一些服务。服务内容描述，服务内容描述",
              "validity": "有效期至：2026-12-31"
            },
            "sub03": {
              "name": "订阅 03",
              "tier": "黄金",
              "note": "服务内容描述，服务内容描述"
            }
          }
        }
      },
      "contextPanel": {
        "ServiceUserInfo": {
          "additionalInfo": "附加信息",
          "email": "邮箱：",
          "postCode": "邮编：",
          "contacts": "联系人"
        },
        "TempNotes": {
          "createdDateTime": "创建时间",
          "createdBy": "创建人",
          "completedDateTime": "完成时间",
          "completedBy": "完成人",
          "status": "状态",
          "note": "备注"
        },
        "NotificationCalls": {
          "createdDateTime": "创建时间",
          "createdBy": "创建人",
          "completedDateTime": "完成时间",
          "completedBy": "完成人",
          "status": "状态",
          "note": "备注"
        },
        "Recommended": {
          "smartContext": "智能上下文",
          "note": "备注",
          "recentCalls": "最近通话"
        },
        "SchemeInfo": {
          "additionalInfo": "附加信息",
          "name": "名称：",
          "postCode": "邮编：",
          "contacts": "联系人"
        },
        "AuthorityInfo": {
          "additionalInfo": "附加信息",
          "name": "名称：",
          "postCode": "邮编：",
          "contacts": "联系人"
        },
        "CaseManagement": {
          "title": "案例管理",
          "ticketConsole": "工单",
          "createTicket": "创建工单",
          "createTicketSuccess": "工单创建成功",
          "ticketId": "工单 ID",
          "createdDateTime": "创建时间",
          "createdBy": "创建人",
          "titleColumn": "标题",
          "description": "描述",
          "category": "类别",
          "priority": "优先级",
          "status": "状态",
          "associateTo": "关联至",
          "linkedDevices": "关联设备",
          "ticketAssignedTo": "工单指派给",
          "attachment": "附件",
          "uploadButton": "上传附件",
          "serviceUserOnlyHint": "请在服务用户档案下查看或创建工单",
          "uploadTypeError": "仅支持 jpg/png/webp 图片和 PDF 文件",
          "uploadSizeError": "单个文件不能超过 10MB",
          "uploadMaxCountError": "最多上传 {{max}} 个文件",
          "selectDevices": "选择设备",
          "selectAssociationFirst": "请先选择关联对象",
          "devicesNotSupportedForRefType": "该关联类型暂不支持选择设备",
          "detailedInformation": "详细信息",
          "addCommentPlaceholder": "添加评论...",
          "createdAt": "创建时间",
          "updatedAt": "更新时间",
          "comment": "评论",
          "statusOptions": {
            "OPEN": "Open",
            "IN_PROGRESS": "In progress",
            "WAITING": "Waiting",
            "CLOSED": "Closed"
          },
          "priorityOptions": {
            "LOW": "低",
            "NORMAL": "普通",
            "HIGH": "高"
          },
          "categoryOptions": {
            "DEVICE_FAULT": "设备故障",
            "CONNECTIVITY": "连接问题",
            "ALARM_HANDLING": "警报处理",
            "ACCOUNT": "账户",
            "OTHER": "其他"
          },
          "validation": {
            "title": "请输入标题",
            "description": "请输入描述",
            "status": "请选择状态",
            "category": "请选择类别",
            "priority": "请选择优先级",
            "associateTo": "请选择关联对象"
          }
        },
        "ContextPanel": {
          "tabs": {
            "recommended": "推荐",
            "information": "详情",
            "sops": "标准作业程序",
            "notificationCall": "通知呼叫",
            "tempNote": "临时备注",
            "audit": "审计",
            "caseManagement": "案例管理",
            "schemes": "计划列表",
            "serviceUsers": "服务用户"
          }
        },
        "AuthoritySchemeList": {
          "schemeName": "计划名称",
          "address": "地址",
          "status": "状态",
          "userNote": "用户备注",
          "search": "搜索"
        },
        "SchemeServiceUserList": {
          "name": "姓名",
          "gender": "性别",
          "dateOfBirth": "出生日期",
          "address": "地址",
          "status": "状态",
          "userNote": "用户备注",
          "search": "搜索"
        },
        "Sops": {
          "description": "{{chapterName}} 的说明"
        }
      }
    },
    "calling": {
      "WaitingControl": {
        "calling": "正在呼叫...",
        "failedToAnswer": "接听失败",
        "failedToReject": "拒接失败"
      },
      "DropdownControl": {
        "failedToMute": "静音操作失败",
        "unmute": "取消静音",
        "mute": "静音",
        "record": "录音",
        "recording": "正在录音",
        "forward": "转接",
        "forwarded": "已转接",
        "forwardSuccess": "转接成功",
        "failedToForward": "转接失败",
        "dial": "拨号",
        "placeholder": {
          "phoneNumber": "请输入电话号码",
          "searchColleague": "搜索同事"
        }
      },
      "Status": {
        "iceRecovering": "ICE 恢复中...",
        "ended": "呼叫结束",
        "calling": "呼叫中",
        "forwarding": "呼叫转移中...",
        "holding": "保持中",
        "recording": "录音中",
        "recordingPaused": "录音已暂停。",
        "callRejected": "通话被拒接",
        "callNoAnswer": "通话未接听",
        "callFailed": "通话失败",
        "canceledByUser": "用户取消",
        "answerTimeout": "接听超时",
        "holdTimeout": "保持超时",
        "unholdTimeout": "取消保持超时",
        "noSessionId": "服务器未返回会话 ID",
        "preparingTimeout": "呼出超时，请重试"
      },
      "Control": {
        "failedToHangup": "挂断失败",
        "failedToHold": "保持/取消保持操作失败",
        "resume": "恢复",
        "speak": "讲话",
        "busyHere": "正忙",
        "rejected": "已拒绝",
        "timeout": "超时"
      },
      "deviceControl": {
        "VolumeControl": {
          "speaker": "扬声器",
          "messages": {
            "noControls": "无控制权限",
            "failedToSendCommand": "发送命令失败"
          }
        },
        "NudgeControl": {
          "nudge": "提醒",
          "messages": {
            "noControls": "无控制项",
            "failedToSendCommand": "发送命令失败"
          }
        },
        "DoorControl": {
          "opened": "已开启",
          "locked": "已锁定"
        }
      },
      "CallingInfo": {
        "labels": {
          "alarmSessionId": "警报会话 ID:",
          "association": "关联:"
        },
        "notificationCall": "通知呼叫",
        "tags": {
          "inbound": "呼入",
          "outbound": "呼出"
        }
      },
      "messages": {
        "callingError": "呼叫错误，请重试"
      },
      "endCause": {
        "ended": "通话结束",
        "noAnswer": "无人接听",
        "cancelled": "已取消",
        "rejected": "已拒接",
        "failed": "呼叫失败"
      },
      "Recording": {
        "failedToResume": "恢复录音失败",
        "failedToStop": "停止录音失败"
      }
    },
    "statistics": {
      "personal": "个人",
      "team": "团队",
      "timeRange": {
        "realTime": "实时",
        "day": "按天",
        "month": "按月"
      },
      "dataOverview": "数据概览",
      "workPerformance": "工作表现",
      "todayTotalDuration": "今日总通话时长",
      "atWork": "在岗",
      "onBreak": "休息",
      "serviceLevel": "服务水平",
      "callsVolume": "通话量",
      "avgHandleTime": "平均通话处理时间",
      "avgResponseTime": "平均通话响应时间",
      "totalCalls": "总通话数",
      "inbound": "呼入",
      "outbound": "呼出",
      "inboundCallStatistics": "呼入通话统计",
      "handledCount": "已接听: {{count}}",
      "rejectedCount": "未接听: {{count}}",
      "overtimeCount": "超时: {{count}}",
      "teamStatus": {
        "title": "话务员状态 - 总计: {{total}}",
        "available": "空闲",
        "incall": "通话中",
        "acw": "话后工作",
        "admin": "忙碌",
        "offline": "离线"
      }
    },
    "admin": {
      "CallLogEdit": {
        "failedToSave": "保存失败，请稍后再试",
        "successfullySaved": "保存成功",
        "save": "保存"
      }
    },
    "widgets": {
      "arcHeader": {
        "menu": {
          "callLogs": "通话记录",
          "statistics": "统计",
          "callOut": "外呼",
          "dialCard": "拨号卡"
        },
        "OperatorInfo": {
          "status": {
            "offline": "离线",
            "available": "空闲",
            "admin": "管理员"
          },
          "online": "在线："
        }
      },
      "AdminStatisticsNav": {
        "callLogs": "通话记录",
        "statistics": "统计"
      },
      "TempNoteEdit": {
        "title": {
          "edit": "编辑临时笔记",
          "create": "创建临时笔记"
        },
        "field": {
          "timeRange": "时间范围",
          "reason": "原因",
          "note": "笔记",
          "alarmType": "警报类型",
          "association": "关联",
          "associateTo": "关联至"
        },
        "placeholder": {
          "startTime": "开始时间",
          "endTime": "结束时间",
          "note": "请输入笔记内容"
        },
        "validation": {
          "selectTimeRange": "请选择时间范围",
          "selectReason": "请选择原因",
          "inputNote": "请输入笔记内容"
        }
      },
      "NotificationCallEdit": {
        "title": {
          "edit": "编辑通知呼叫",
          "create": "创建通知呼叫"
        },
        "field": {
          "selectPeriod": "选择周期",
          "reason": "原因",
          "note": "备注",
          "association": "关联",
          "timeRange": "时间范围",
          "associateTo": "关联至"
        },
        "validation": {
          "selectPeriod": "请选择通知类型",
          "selectReason": "请选择原因",
          "inputNote": "请输入备注",
          "selectTimeRange": "请选择时间范围"
        }
      },
      "SearchModal": {
        "title": "搜索 ARC",
        "placeholder": {
          "search": "搜索",
          "searchEverything": "搜索所有内容"
        },
        "noResults": "未找到结果。",
        "searchFailed": "搜索失败。请重试。",
        "columns": {
          "name": "姓名",
          "info": "信息",
          "address": "地址"
        },
        "phoneNumbers": "电话号码",
        "scopes": {
          "all": "全部",
          "serviceUser": "服务用户",
          "scheme": "计划",
          "authority": "机构",
          "contact": "联系人"
        },
        "types": {
          "service_user": "服务用户",
          "service_scheme": "计划",
          "authority": "机构",
          "contact": "联系人"
        }
      },
      "RejectCallReasonForm": {
        "title": "拒接原因",
        "field": {
          "reason": "原因",
          "description": "描述"
        },
        "validation": {
          "selectReason": "请选择原因"
        },
        "messages": {
          "failedToSubmit": "提交失败"
        }
      },
      "arcBackgroundTask": {
        "InitUnCompletedCallings": {
          "title": "您有一项未完成的处理",
          "message": "请完成剩余步骤。"
        }
      },
      "statusIndicator": {
        "sip": {
          "new": "新建",
          "checking": "检查中",
          "connected": "已连接",
          "disconnected": "已断开",
          "failed": "失败",
          "closed": "已关闭",
          "completed": "已完成"
        },
        "register": {
          "unregistered": "未注册",
          "registered": "已注册",
          "registerFailed": "注册失败",
          "registrationExpiring": "注册即将过期"
        }
      },
      "operationPanel": {
        "markAsDone": "标记为完成",
        "tempNote": "临时笔记",
        "notificationCall": "通知呼叫",
        "messages": {
          "saveSuccess": "通话日志保存成功",
          "saveFailed": "保存通话日志失败",
          "statusUpdateFailed": "更新话务员状态失败"
        }
      },
      "associationSelect": {
        "title": "选择关联",
        "associateTo": "通话关联至",
        "search": "搜索",
        "serviceUser": "服务用户",
        "scheme": "计划",
        "authority": "机构",
        "columns": {
          "name": "姓名",
          "birthday": "生日",
          "age": "年龄",
          "gender": "性别",
          "salesType": "销售类型",
          "status": "状态",
          "address": "地址"
        }
      },
      "offline": {
        "OfflinePage": {
          "currentlyOffline": "当前离线",
          "available": "空闲",
          "admin": "管理员",
          "logout": "退出登录",
          "messages": {
            "failedToUpdate": "更新状态失败"
          }
        }
      },
      "available": {
        "AvailablePage": {
          "operatorsAhead": "前方空闲话务员："
        }
      },
      "viser": {
        "notification": {
          "supervisor": "通知 告知主管一些值得注意的事情"
        },
        "waitingCalls": {
          "messages": {
            "accepted": "您已成功接听该呼叫。",
            "acceptedHandleElsewhere": "您已成功接听该呼叫。请在“通话”页面进行后续处理。"
          }
        }
      },
      "components": {
        "listItems": {
          "SubscriptionItem": {
            "validUntil": "有效期至：{{date}}"
          }
        }
      }
    },
    "callLogs": {
      "DateRangeInput": {
        "last7Days": "最近 7 天",
        "last30Days": "最近 30 天",
        "last90Days": "最近 90 天",
        "last6Months": "最近 6 个月",
        "startDate": "开始日期",
        "endDate": "结束日期"
      },
      "CallLogsSearch": {
        "dateTimeRange": "日期/时间范围",
        "callerRecipient": "呼叫者/接收者",
        "associateTo": "关联至",
        "callType": "通话类型",
        "searchType": "搜索类型",
        "operator": "话务员",
        "search": "搜索",
        "apply": "应用",
        "reset": "重置",
        "options": {
          "reason": "原因",
          "outcome": "结果",
          "note": "笔记",
          "serviceUser": "服务用户",
          "contact": "联系人",
          "connection": "连接",
          "other": "其他",
          "scheme": "计划",
          "authority": "机构",
          "inbound": "呼入",
          "outbound": "呼出",
          "me": "我",
          "others": "其他"
        }
      },
      "callLogsColumns": {
        "dateTime": "日期和时间",
        "callerRecipient": "呼叫者/接收者",
        "associateTo": "关联至",
        "callType": "通话类型",
        "reason": "原因",
        "outcome": "结果",
        "operator": "话务员",
        "missed": "未接听",
        "rejected": "已拒绝",
        "waiting": "等待中",
        "pending": "处理中",
        "inProgress": "进行中",
        "ended": "已结束",
        "completed": "已完成"
      }
    }
  },
  "operatorStatus": {
    "update": {
      "failed": "状态更新失败"
    },
    "offlineReason": "离线原因",
    "field": {
      "reason": "原因",
      "description": "描述"
    },
    "validation": {
      "selectReason": "请选择原因"
    }
  },
  "audit": {
    "dateTime": "日期时间",
    "operationType": "操作类型",
    "field": "字段",
    "modifier": "修改者",
    "modifiedFields": "修改字段",
    "oldValue": "旧值",
    "newValue": "新值",
    "search": "搜索"
  }
}
